import React, { useEffect } from "react";
import { PageSummary_SearchRequest } from "../Models/Model";
import { ContainerType, PageType } from "../Models/Enum";
import { SimpleResponse } from "../Models/ResponseModel";
import pageService from "../Services/pageService";
import { IMAGE_MAIN_ENDPOINT } from "../constant";


function ImageBanner(props){     
  
    function getTemplate() {
     
        let Template =  <div>
                       
        <img className='img-fluid '  style={{width:'100%'}}  src={IMAGE_MAIN_ENDPOINT+(props.data) } />
       
    </div>   
   

        if(props.FldMapType == 48){
            Template  = <div className='row position-relative mangoTrail' style={{  backgroundColor: '#3a785d',  backgroundImage: "url("+ IMAGE_MAIN_ENDPOINT+  (props.data)}}  >

                {/* <img className='img-fluid ' src={"https://localhost:44376/Process/GetFiles_Pages?FileName=" + (props.data) + "&ContainerType=Main"} /> */}
            </div>     
        
    }
    return Template
}
   
    return (
        <div className="row">
            <div className="col ps-0 pe-0">             
                {getTemplate()}
            </div>
        </div>


    )
}


export default ImageBanner